// Static data for Cloudflare Pages deployment (no backend required)

export const PROPERTY_DATA = {
  name: "South Shore Suites",
  tagline: "Your Perfect Bayfield Getaway",
  subtitle: "Stylish Suites Near Grand Bend & Lake Huron",
  address: "75357 Bluewater Highway, Bayfield, Ontario",
  description: "Escape to Bayfield – just 15 minutes from Grand Bend Beach and a short drive to Bayfield Pier. Our stylish, renovated suites feature full kitchens, A/C, fast WiFi, Smart TVs, and complimentary coffee. Enjoy our seasonal pool, hot tub, fire pits, BBQs, and free private parking.",
  distance_to_beach: "3.8 km to Bayfield Pier Beach",
  distance_to_grand_bend: "15 minutes to Grand Bend Beach",
  host: {
    name: "Logan",
    title: "Superhost",
    years_hosting: 2,
    total_reviews: 283,
    rating: 4.76,
    response_rate: "100%",
    response_time: "within an hour"
  },
  shared_amenities: [
    { name: "Seasonal Pool", icon: "waves", description: "24/7 access, lit at night" },
    { name: "Hot Tub", icon: "sparkles", description: "Relax under the stars" },
    { name: "3 Fire Pits", icon: "flame", description: "Perfect for evening gatherings" },
    { name: "Free Parking", icon: "car", description: "Private parking included" },
    { name: "BBQ Grills", icon: "utensils", description: "Propane provided" },
    { name: "Pet Friendly", icon: "paw", description: "$50 per pet per stay" },
    { name: "High-Speed WiFi", icon: "wifi", description: "Throughout property" },
    { name: "Self Check-in", icon: "key", description: "Keypad entry" }
  ],
  property_images: [
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/to1ypjb2_1.JPG",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/odrqm6ki_2.jpeg",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/2kpf2zwd_3.jpeg",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/5u89jamd_4.jpeg"
  ],
  property_images_mobile: [
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/er3ktv1i_1.png",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/uu5i0ut8_2.png",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/q8co0h3u_3.png",
    "https://customer-assets.emergentagent.com/job_nice-tesla-1/artifacts/53nmqpa2_4.png"
  ]
};

export const ROOMS_DATA = [
  {
    id: "suite-1",
    name: "Sunset Queen Suite",
    subtitle: "Suite 1",
    sleeps: 3,
    bedrooms: 1,
    beds: "1 Queen + Futon",
    bathrooms: 1,
    rating: 4.9,
    reviews: 40,
    badge: "Guest Favourite",
    description: "Escape to comfort in our cozy, fully-equipped suite. Perfect for 3 guests with queen bed and futon. Features private patio, 2 smart TVs, and full kitchen.",
    features: ["Full Kitchen", "Private Bathroom", "2 Smart TVs", "A/C & Heat", "Private Patio", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208281063468906113/original/f8043312-463a-42ac-95dd-8c7997bab6bf.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208281063468906113/original/141c0ea7-b912-40d2-99c2-2acee970a08c.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208281063468906113/original/69dd59e3-08ec-43b2-b289-0152ba86428a.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208281063468906113/original/da870bd6-fa40-4bdc-9da6-9068bf41928d.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208281063468906113/original/0248d250-c2d1-4b92-9e03-fd6664d05588.jpeg"
    ]
  },
  {
    id: "suite-2",
    name: "Seashell Queen Suite",
    subtitle: "Suite 2",
    sleeps: 3,
    bedrooms: 1,
    beds: "1 Queen + Futon",
    bathrooms: 1,
    rating: 4.8,
    reviews: 30,
    description: "Cozy retreat with queen bed and futon for extra guest. Fully equipped kitchen, private bathroom, and your own private patio with BBQ.",
    features: ["Full Kitchen", "Private Bathroom", "2 Smart TVs", "A/C & Heat", "Private Patio", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293735813870379/original/bbb31fb4-6433-4230-b7cf-31df0dfb927a.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293735813870379/original/3cf7d6ce-702a-4da1-9a4e-86856f131fd4.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293735813870379/original/a6cbcb9e-dc00-44f3-99c3-4ddf89d10f78.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293735813870379/original/2d6bb764-4962-480d-a30f-acef8e6eb613.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293735813870379/original/0e1e51c5-5e0f-4a72-89ec-e2fbe518786b.jpeg"
    ]
  },
  {
    id: "suite-3",
    name: "Tidal Double Suite",
    subtitle: "Suite 3",
    sleeps: 5,
    bedrooms: 1,
    beds: "2 Double Beds",
    bathrooms: 1,
    rating: 4.86,
    reviews: 44,
    description: "Perfect for families or small groups with 2 double beds. Full kitchen, dining area, and private patio for relaxing.",
    features: ["Full Kitchen", "Dining Area", "2 Smart TVs", "A/C & Heat", "Private Patio", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293467906424185/original/3cf6b2f8-9fa9-487b-8e0e-66615833662a.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293467906424185/original/21105a8d-e7ae-49e9-9087-eb727d7df011.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293467906424185/original/d6ae35e8-0cd9-4460-bd44-a194b511357b.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293467906424185/original/555dfd33-0e7d-4f47-b007-343a06b646ed.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208293467906424185/original/07f3ed9e-88e6-4c97-addb-e7e889f02041.jpeg"
    ]
  },
  {
    id: "suite-4",
    name: "Driftwood Double Suite",
    subtitle: "Suite 4",
    sleeps: 5,
    bedrooms: 1,
    beds: "2 Double Beds",
    bathrooms: 1,
    rating: 4.68,
    reviews: 25,
    description: "Family-friendly suite with 2 double beds. Full kitchen with modern appliances, private patio for morning coffee, and BBQ for outdoor cooking.",
    features: ["Full Kitchen", "Dining Area", "2 Smart TVs", "A/C & Heat", "Private Patio", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208704973815749705/original/5b3e3b33-d4a4-46e7-bda1-6b9af23b54e3.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208704973815749705/original/557798e6-75e8-4ec1-9c48-1280fc2ee5ce.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208704973815749705/original/aa5ea97e-6819-4903-89b9-84369abe429b.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208704973815749705/original/14c750ce-74d8-43a9-838f-8b10ce769ded.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208704973815749705/original/470001a0-7255-4592-8627-e7b6a86610cd.png"
    ]
  },
  {
    id: "suite-5",
    name: "Seaglass King Suite",
    subtitle: "Suite 5",
    sleeps: 3,
    bedrooms: 1,
    beds: "1 King + Futon",
    bathrooms: 1,
    rating: 4.75,
    reviews: 32,
    badge: "Pool View",
    description: "Premium suite with king bed and private patio just steps from the pool. Tall hedges provide near-complete privacy for ultimate relaxation.",
    features: ["King Bed", "Pool-Facing Patio", "Full Kitchen", "2 Smart TVs", "Privacy Hedges", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208736971100015510/original/797ebd6b-349d-406b-a97c-3f0111aeb55e.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208736971100015510/original/f4ea6599-65b9-4c63-912e-eee097443bb2.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208736971100015510/original/f7c36389-8a16-484c-a973-415c1b941296.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208736971100015510/original/ad43a56a-f97e-4a78-89bc-364073f6df5b.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208736971100015510/original/0720c4b9-6538-4ed8-8421-c1555389ec71.jpeg"
    ]
  },
  {
    id: "suite-6",
    name: "Lighthouse King Suite",
    subtitle: "Suite 6",
    sleeps: 3,
    bedrooms: 1,
    beds: "1 King + Futon",
    bathrooms: 1,
    rating: 4.82,
    reviews: 28,
    badge: "2nd Largest",
    description: "Our second-largest suite with king bed and massive private covered patio. Perfect for outdoor dining and enjoying the countryside views.",
    features: ["King Bed", "XL Covered Patio", "Full Kitchen", "2 Smart TVs", "Lounge Area", "Private BBQ"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208754529453228303/original/47ed75e7-5c71-49e7-a92f-cd7ab37bf9f4.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208754529453228303/original/50f6c9d2-7c36-4a04-bab1-ce4b05bad5d4.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208754529453228303/original/6d8f038b-875d-4488-9537-f9e1eb2594c0.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208754529453228303/original/ebafa574-7077-40f4-9fe2-f758c18008b2.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1208754529453228303/original/0b53d6a2-ebd7-4180-838b-98194a6d94ea.png"
    ]
  },
  {
    id: "suite-7",
    name: "The Captain's Quarters",
    subtitle: "Suite 7",
    sleeps: 7,
    bedrooms: 2,
    beds: "1 King + 2 Double + Futon",
    bathrooms: 1,
    rating: 4.79,
    reviews: 34,
    badge: "Largest Suite",
    description: "The crown jewel of our property! Only suite on the second floor with beautiful Bayfield countryside views. Two bedrooms, full-size kitchen, and covered patio.",
    features: ["2 Bedrooms", "King Bed", "Countryside Views", "Full Kitchen", "Dining Room", "Covered Patio"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/628e19c5-088b-4e2c-89e1-149343932e38.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/594db850-23e7-450c-be61-0295b0ae480b.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/982e9f90-4203-4c89-86b8-9dccf8744f8c.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/e93a133b-ad38-48f3-a200-49476fee3a5c.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/2c77e896-3274-4c3e-9bb9-d57bc3ddbcbb.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1220627716008516910/original/0999a775-9e5e-42c8-b0f9-d0fd76d155fa.jpeg"
    ]
  },
  {
    id: "suite-8",
    name: "Canopy Queen Suite",
    subtitle: "Suite 8",
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Queen Bed",
    bathrooms: 1,
    rating: 4.84,
    reviews: 19,
    badge: "Unique Stay",
    description: "Modern loft charm with queen bed in loft-style sleeping area. Kitchenette with full-size fridge, walk-in shower, and extra-large covered patio with countryside views.",
    features: ["Loft Bedroom", "Kitchenette", "Walk-in Shower", "Smart TV", "XL Covered Patio", "Private BBQ"],
    note: "Must climb ladder to access loft bed",
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437011918517633279/original/64c42893-ad89-43f2-9571-2f39b0a9fe47.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437011918517633279/original/0db0edd8-e16a-4369-8866-720105163a30.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437011918517633279/original/a2480210-e200-41c0-a2b4-0287aa96d8dd.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437011918517633279/original/a508cf90-1def-42d1-a18f-2c625119d12c.png",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437011918517633279/original/ab07d328-c625-406d-ba64-b3ade00d440f.jpeg"
    ]
  },
  {
    id: "suite-9",
    name: "Treehouse Double Suite",
    subtitle: "Suite 9",
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Double Bed",
    bathrooms: 1,
    rating: 4.36,
    reviews: 14,
    badge: "Kids Favourite",
    description: "Cozy loft-style retreat perfect for solo travelers or couples. Features loft sleeping area with double bed, plus massive private covered patio.",
    features: ["Loft Bedroom", "XL Covered Patio", "Kitchenette", "Smart TV", "Private BBQ"],
    note: "Must climb ladder to access loft bed",
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437036519915811950/original/e1478ed6-1491-489a-9af9-a5faf105c274.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437036519915811950/original/a64e9c85-e720-4dbe-ab62-f970d1285738.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437036519915811950/original/cc733322-42a9-482c-9524-2447193c4ff2.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437036519915811950/original/c1dda5a9-38c8-436f-a055-0db65b5066b1.jpeg",
      "https://a0.muscache.com/im/pictures/hosting/Hosting-1437036519915811950/original/700138f0-d1a3-4f73-b736-f75c736803a8.jpeg"
    ]
  },
  {
    id: "suite-10",
    name: "Cottage Suite",
    subtitle: "Suite 10",
    sleeps: 2,
    bedrooms: 1,
    beds: "1 Queen Bed",
    bathrooms: 1,
    rating: 5.0,
    reviews: 0,
    badge: "New",
    description: "Cozy cottage-style suite perfect for couples. Features a comfortable queen bed, modern amenities, and a peaceful countryside atmosphere.",
    features: ["Queen Bed", "Kitchenette", "Smart TV", "Private Entrance", "Countryside Views"],
    airbnb_url: "https://hotel2743.openhotel.com/results.cfm",
    images: [
      "/cottage/IMG_7172.JPG",
      "/cottage/IMG_7176.JPG",
      "/cottage/IMG_7178.JPG",
      "/cottage/IMG_7181.JPG",
      "/cottage/IMG_7204.JPG",
      "/cottage/IMG_7221.JPG",
      "/cottage/IMG_7234.JPG",
      "/cottage/IMG_7246.JPG",
      "/cottage/IMG_7272.JPG",
      "/cottage/IMG_7274.JPG",
      "/cottage/IMG_7279.JPG",
      "/cottage/IMG_7283.JPG",
      "/cottage/IMG_7284.JPG",
      "/cottage/IMG_7285.JPG",
      "/cottage/IMG_5728.JPG"
    ]
  }
];

export const REVIEWS_DATA = {
  total_reviews: 200,
  average_rating: 4.76,
  platforms: [
    { platform: "Google", color: "#4285F4" },
    { platform: "Airbnb", color: "#FF5A5F" },
    { platform: "Booking.com", color: "#003580" }
  ],
  highlights: [
    { category: "Cleanliness", mentions: 89 },
    { category: "Hospitality", mentions: 120 },
    { category: "Location", mentions: 75 },
    { category: "Pool & Hot Tub", mentions: 68 }
  ],
  featured_reviews: [
    // Set 1
    { name: "Hazel Kate Dianon", rating: 5, platform: "Google", text: "Pool was fantastic. Hot tub was the best. Firepit at night made the evenings perfect for drinks and chatting. Suites are roomy and very clean u can smell how clean when u walk in. Overall really relaxing. Would stay here again just to unwind.", set: 1 },
    { name: "Pubuduni", rating: 5, platform: "Airbnb", text: "This place is absolutely beautiful and very well organized. Every detail has been carefully considered from the overall ambiance to the small touches that truly make a difference. I was especially impressed to see the provided items in the washroom, such a thoughtful gesture that shows how much they care. Hats off to the team! I absolutely loved the place", set: 1 },
    { name: "Julie", rating: 5, platform: "Booking.com", text: "We had a fantastic experience at South Shore Suites! From the moment we arrived, everything exceeded our expectations. The owner was incredibly kind and considerate, even allowing an early check-in which made our arrival smoother. The suite was spotless, beautifully maintained, and felt just like home. Spacious, clean, and equipped with all the amenities we needed for a comfortable and relaxing stay. Highly recommend – we'll definitely be back!", set: 1 },
    // Set 2
    { name: "Reina Facchinato", rating: 5, platform: "Google", text: "Stayed for my bachelorette party in room 7 and it was amazing. 2 minutes from Bayfield where we had dinner. Logan was great and so accommodating, the room was wonderful and the cleaning ladies are honestly the most wonderful people I've ever met! The hot tub was amazing and well kept up with. The small details around the room and bathroom was really thoughtful as well! Will definitely be going back! Keep up the great work south shore!! 😊", set: 2 },
    { name: "Yamania", rating: 5, platform: "Airbnb", text: "We had a very pleasant stay at this place. It was a family trip with kids and pets, and everyone had a great time. The house is beautiful, with plenty of space to enjoy together. We loved the pool and jacuzzi, and our dogs were also very comfortable throughout the stay. Logan is an excellent host—very attentive and welcoming. The atmosphere is peaceful and perfect for relaxing and spending quality time. Overall, we loved the place and will definitely be coming back. Highly recommended!", set: 2 },
    { name: "De", rating: 5, platform: "Booking.com", text: "Our first time renting a property like this, and we loved everything! The suite had all the facilities we needed, felt like a true home away from home, and offered excellent value. We appreciated every detail, and the discounted rate was a nice bonus.", set: 2 },
    // Set 3
    { name: "Lisa Wallace", rating: 5, platform: "Google", text: "We stayed here Aug 25-29 Suite 1. It's the perfect spot between Bayfield & Grand Bend. The best of both worlds. Perfect! So many beaches to choose from. There is a great pool & hot tub. The kitchen is perfect to make a breakfast before you head out for the day. Coffee maker WITH coffee grinds to brew REAL coffee!", set: 3 },
    { name: "Carey", rating: 5, platform: "Airbnb", text: "I had a great stay here with my daughter. Logan was always quick to reply with any questions and he made us feel welcomed. The suite was clean, bright and perfect for our 3 day vacation. It is in a great location, about 20 min drive to Grand Bend and Goderich. Bayfield is just a little ways down the road, its a very quaint beautiful little town.", set: 3 },
    { name: "Nuñez", rating: 5, platform: "Booking.com", text: "Everything was amazing! The suite was very clean, AC worked perfectly, and it stayed nice and cool inside. The hot tub was spotless and relaxing.", set: 3 },
    // Set 4
    { name: "Victoria Rojas", rating: 5, platform: "Google", text: "Great spot to spend a few nights. Rooms were clean and stocked with all you could need for a short stay. The BBQ was a bonus for us. Logan was super accommodating and friendly. Only a short drive to Grand Bend, Bayfield, and Goderich.", set: 4 },
    { name: "Reaghen", rating: 5, platform: "Airbnb", text: "Just a few minutes to town and a few minutes to the beach. Logan's place was perfect for us. Loved that there was a living area with kitchen and a separate bedroom. We were happy that we could bring our 4 month puppy and there was enough room for the dog crate. No concerns from us! Will be back if we find ourselves coming to Bayfeild again!", set: 4 },
    { name: "Nedie", rating: 5, platform: "Booking.com", text: "We had a wonderful 2-night stay. The property was very clean, quiet, and comfortable – perfect for a relaxing break. The staff were warm and welcoming, and the location made beach hopping easy, close to Grand Bend, Goderich Beach, and charming small towns. Highly recommend for anyone looking for a peaceful getaway near the water.", set: 4 }
  ]
};

export const ATTRACTIONS_DATA = {
  beaches: [
    { name: "Bayfield Pier Beach", distance: "3.8 km", time: "5 min drive", description: "Beautiful beach with pier, free parking" },
    { name: "Grand Bend Main Beach", distance: "15 min drive", description: "Large, lively beach with shops, restaurants, entertainment" },
    { name: "Pinery Provincial Park", distance: "20 min drive", description: "Hiking, biking, canoeing, and pristine beaches" },
    { name: "Goderich Beach", distance: "25-30 min drive", description: "Wide boardwalk, beautiful bluffs, stunning sunsets" }
  ],
  dining: [
    { name: "Black Dog Village Pub & Bistro", address: "5 Main St. S, Bayfield", vibe: "Cozy gastropub with elevated pub fare" },
    { name: "Bayfield Brewing Co.", address: "14 Main St N, Bayfield", vibe: "Craft brewery with fresh pints and pub grub" },
    { name: "Albion Hotel", address: "1 Main St, Bluewater", vibe: "Historic English-style pub with BBQ platters" },
    { name: "Copenhagen's Ice Cream", address: "8 Main St, Bayfield", vibe: "Classic fish and chips, tacos, and ice cream" }
  ],
  activities: [
    { name: "Bayfield Marina", description: "Fishing spots and boat rentals" },
    { name: "Historic Downtown Bayfield", description: "Charming shops, restaurants, LCBO - 2 min away" },
    { name: "Huron Country Playhouse", description: "Live theatre - musicals, comedies, family shows" },
    { name: "Bad Apple Brewing", description: "Craft brewery on apple orchard - 5 min drive" }
  ]
};
